<template>
  <div>
    <div class="card-body">
      <table class="table table-sm table-bordered">
        <thead class="bg-custom">
          <tr>
            <th>Name</th>
            <th>Address</th>
            <th>CNIC/Passport No</th>
            <th>% of share held</th>
            <th>Issue Date</th>
            <th>PEP Yes/No</th>
            <th>Self Position</th>
            <th>Association/Relationship</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in records" :key="index">
            <td>
              <input v-model="record.BO_NAME" type="text" class="table-input" />
            </td>
            <td>
              <input v-model="record.BO_ADDRESS" type="text" class="table-input" />
            </td>
            <td>
              <input v-model="record.BO_CNICPASSNO" type="text" maxlength="13" minlength="5" pattern="[0-9]{5,13}" class="table-input" />
            </td>
            <td>
              <input v-model="record.BO_SHAREPERCENTAGE" type="number" class="table-input" />
            </td>
            <td>
              <input v-model="record.BO_CNICPASS_ISSUEDTE" type="date" class="table-input" />
            </td>
            <td>
              <select v-model="record.BO_PEPYN" class="table-input">
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </select>
            </td>
            <td>
              <input v-model="record.BO_IFYESSELFPOSITION" type="text" class="table-input" />
            </td>
            <td>
              <input v-model="record.BO_ASSOCRELWITHPEP" type="text" class="table-input" />
            </td>
            <td>
              <button class="btn btn-danger btn-sm" @click="deleteRecord(index)"><i class="fas fa-trash" /></button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="9">
              <button class="btn btn-block btn-secondary" type="button" @click="openModal">Add New</button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>


    <div class="card-footer">
      <button class="btn btn-success float-right mr-1" @click="submitForm">Submit</button>
    </div>

    <div class="modal fade show" data-backdrop="static" id="addEntryModal" aria-modal="true" role="dialog">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-custom">
            <h4 class="modal-title">Add Benificial Detail</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" style="color:white">×</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label class="form-label">Name</label>
                <input v-model="newRecord.BO_NAME" type="text" class="form-control" />
              </div>
              <div class="mb-3">
                <label class="form-label">Address</label>
                <input v-model="newRecord.BO_ADDRESS" type="text" class="form-control" />
              </div>
              <div class="mb-3">
                <label class="form-label">CNIC/NICOP/PASSPORT/REGISTATION NO.</label>
                <input v-model="newRecord.BO_CNICPASSNO" type="text" maxlength="13" minlength="5" pattern="[0-9]{5,13}" class="form-control" />
              </div>
              <div class="mb-3">
                <label class="form-label">% of share held</label>
                <input v-model="newRecord.BO_SHAREPERCENTAGE" type="number" class="form-control" />
              </div>
              <div class="mb-3">
                <label class="form-label">Issue Date</label>
                <input v-model="newRecord.BO_CNICPASS_ISSUEDTE" type="date" class="form-control" />
              </div>
              <div class="mb-3">
                <label class="form-label">PEP Yes/No</label>
                <select v-model="newRecord.BO_PEPYN" class="form-control">
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">Self Position</label>
                <input v-model="newRecord.BO_IFYESSELFPOSITION" type="text" class="form-control" />
              </div>
              <div class="mb-3">
                <label class="form-label">Association/Relationship</label>
                <input v-model="newRecord.BO_ASSOCRELWITHPEP" type="text" class="form-control" />
              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="addRecord">Add Entry</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { Modal } from 'bootstrap';

  export default {
    props: {
      clientid: Number,
    },
    data() {
      return {
        records: [],
        newRecord: {
          BP_ID: this.clientid,
          BO_NAME: '',
          BO_ADDRESS: '',
          BO_CNICPASSNO: '',
          BO_CNICPASS_ISSUEDTE: '',
          BO_SHAREPERCENTAGE: '',
          BO_PEPYN: 'N',
          BO_IFYESSELFPOSITION: '-',
          BO_ASSOCRELWITHPEP: '-',
          BO_ISBENIFICIARY: 'Y',
          BO_ISDIRECTOR: 'N'
        },
      };
    },
    created() {
      this.pageLoad();
    },
    methods: {
      pageLoad() {
        var vm = this;
        axios.get("/api/UICApi/pageLoadBeneficialOwnership?ID=" + this.clientid)
          .then(function (res) {
            vm.records = res.data.records.map(r => ({
              ...r,
              BO_PEPYN: r.BO_PEPYN || 'N',
              BO_IFYESSELFPOSITION: r.BO_IFYESSELFPOSITION || '-',
              BO_ASSOCRELWITHPEP: r.BO_ASSOCRELWITHPEP || '-',
              BO_ADDRESS: r.BO_ADDRESS || ''
            }));
          })
      },
      openModal() {
        this.newRecord = {
          BP_ID: this.clientid,
          BO_NAME: '',
          BO_ADDRESS: '',
          BO_CNICPASSNO: '',
          BO_CNICPASS_ISSUEDTE: '',
          BO_SHAREPERCENTAGE: 0,
          BO_PEPYN: 'N',
          BO_IFYESSELFPOSITION: '-',
          BO_ASSOCRELWITHPEP: '-',
          BO_ISBENIFICIARY: 'Y',
          BO_ISDIRECTOR: 'N'
        };
        $("#addEntryModal").modal("show");
      },
      addRecord() {
        if (this.newRecord.BO_NAME && this.newRecord.BO_ADDRESS && this.newRecord.BO_CNICPASSNO && this.newRecord.BO_SHAREPERCENTAGE && this.newRecord.BO_CNICPASS_ISSUEDTE && this.newRecord.BO_PEPYN && this.newRecord.BO_IFYESSELFPOSITION && this.newRecord.BO_ASSOCRELWITHPEP) {
          this.records.push({ ...this.newRecord });
          $("#addEntryModal").modal("hide");
        } else {
          toastr.error('Please fill in required fields');
        }
      },
      deleteRecord(index) {
        if (confirm('Are you sure you want to delete this record?')) {
          this.records.splice(index, 1);
        }
      },
      submitForm(e) {
        var vm = this;
        e.preventDefault();

        vm.records = vm.records.map(r => ({
          ...r,
          BO_PEPYN: r.BO_PEPYN || 'N',
          BO_IFYESSELFPOSITION: r.BO_IFYESSELFPOSITION || '-',
          BO_ASSOCRELWITHPEP: r.BO_ASSOCRELWITHPEP || '-',
          BO_ADDRESS: r.BO_ADDRESS || ''
        }));

        startReq();
        axios.post('/api/UICApi/SaveBeneficialOwnership', {
          records: vm.records,
        })
          .then(response => {
            endReq();
            if (response.data.status) {
              toastr.success(response.data.msg)
              vm.clearForm();
            }
            else {
              toastr.error(response.data.msg)
            }
          })
          .catch(error => {
            endReq();
            vm.error = 'Error saving BenificialOwnership';
            console.log(error);
          })
      }
    }
  };
</script>

<style scoped>
  .info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 20px;
  }

  .info-field {
    display: flex;
    flex-direction: column;
  }

  .table td {
    padding: 4px !important; 
    vertical-align: middle;
  }

  .table-input {
    width: 100%;
    height: 30px; 
    padding: 2px 6px; 
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 13px;
  }
  .info-input {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/BenificialOwnership.vue